<template>
  <form
    :action="`/gift_card_tickets/${ticketToken}/delivery_addresses/confirm`"
    accept-charset="UTF-8"
    method="post"
  >
    <input name="utf8" type="hidden" value="✓" />
    <input type="hidden" name="authenticity_token" :value="authenticityToken" />
    <DeliveryAddressNewFormInputs
      ref="deliveryAddressNewFormInputs"
      :prefectures="prefectures"
      :last-name="lastName"
      :first-name="firstName"
      :last-name-kana="lastNameKana"
      :first-name-kana="firstNameKana"
      :zip-code="zipCode"
      :prefecture="prefecture"
      :address1="address1"
      :address2="address2"
      :last-name-error-message="lastNameErrorMessage"
      :first-name-error-message="firstNameErrorMessage"
      :last-name-kana-error-message="lastNameKanaErrorMessage"
      :first-name-kana-error-message="firstNameKanaErrorMessage"
      :zip-code-error-message="zipCodeErrorMessage"
      :prefecture-error-message="prefectureErrorMessage"
      :address1-error-message="address1ErrorMessage"
      :address2-error-message="address2ErrorMessage"
      :ticket-usable-limit-at="ticketUsableLimitAt"
      @change-last-name="onChangeLastName"
      @change-first-name="onChangeFirstName"
      @change-last-name-kana="onChangeLastNameKana"
      @change-first-name-kana="onChangeFirstNameKana"
      @change-zip-code="onChangeZipCode"
      @change-prefecture="onChangePrefecture"
      @change-address1="onChangeAddress1"
      @change-address2="onChangeAddress2"
    />
    <DeliveryAddressNewFormContacts
      :phone-number="phoneNumber"
      :email="email"
      :phone-number-error-message="phoneNumberErrorMessage"
      :email-error-message="emailErrorMessage"
      @change-phone-number="onChangePhoneNumber"
      @change-email="onChangeEmail"
    />
    <DeliveryAddressNewFormSubmits
      :is-agreed-privacy-policy="isAgreedPrivacyPolicy"
      :is-over-twenty="isOverTwenty"
      :is-alcohol-item="isAlcoholItem"
      :over-twenty-check-error-message="overTwentyCheckErrorMessage"
      :showable-agreed-privacy-policy-error-message="
        showableAgreedPrivacyPolicyErrorMessage
      "
      :is-submittable="isSubmittable"
      @change-is-agreed-privacy-policy="onChangeIsAgreedPrivacyPolicy"
      @change-is-over-twenty="onChangeIsOverTwenty"
    />
  </form>
</template>

<script>
import DeliveryAddressNewFormInputs from './DeliveryAddressNewFormInputs.vue'
import DeliveryAddressNewFormContacts from './DeliveryAddressNewFormContacts.vue'
import DeliveryAddressNewFormSubmits from './DeliveryAddressNewFormSubmits.vue'

export default {
  components: {
    DeliveryAddressNewFormSubmits,
    DeliveryAddressNewFormContacts,
    DeliveryAddressNewFormInputs
  },
  props: {
    authenticityToken: {
      type: String,
      required: true
    },
    prefectures: {
      type: Array,
      required: true
    },
    lastName: {
      type: String,
      required: true
    },
    firstName: {
      type: String,
      required: true
    },
    lastNameKana: {
      type: String,
      required: true
    },
    firstNameKana: {
      type: String,
      required: true
    },
    zipCode: {
      type: String,
      required: true
    },
    prefecture: {
      type: String,
      required: true
    },
    address1: {
      type: String,
      required: true
    },
    address2: {
      type: String,
      required: true
    },
    phoneNumber: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    isAgreedPrivacyPolicy: {
      type: Boolean,
      required: true
    },
    isOverTwenty: {
      type: Boolean,
      required: true
    },
    isAlcoholItem: {
      type: Boolean,
      required: false
    },
    ticketToken: {
      type: String,
      required: true
    },
    lastNameErrorMessage: {
      type: String,
      required: true
    },
    firstNameErrorMessage: {
      type: String,
      required: true
    },
    lastNameKanaErrorMessage: {
      type: String,
      required: true
    },
    firstNameKanaErrorMessage: {
      type: String,
      required: true
    },
    zipCodeErrorMessage: {
      type: String,
      required: true
    },
    prefectureErrorMessage: {
      type: String,
      required: true
    },
    address1ErrorMessage: {
      type: String,
      required: true
    },
    address2ErrorMessage: {
      type: String,
      required: true
    },
    phoneNumberErrorMessage: {
      type: String,
      required: true
    },
    emailErrorMessage: {
      type: String,
      required: true
    },
    overTwentyCheckErrorMessage: {
      type: String,
      required: true
    },
    showableAgreedPrivacyPolicyErrorMessage: {
      type: Boolean,
      required: true
    },
    isSubmittable: {
      type: Boolean,
      required: true
    },
    ticketUsableLimitAt: {
      type: String,
      required: true
    }
  },
  methods: {
    onChangeLastName(value) {
      this.$emit('change-last-name', value)
    },
    onChangeFirstName(value) {
      this.$emit('change-first-name', value)
    },
    onChangeLastNameKana(value) {
      this.$emit('change-last-name-kana', value)
    },
    onChangeFirstNameKana(value) {
      this.$emit('change-first-name-kana', value)
    },
    onChangeZipCode(value) {
      this.$emit('change-zip-code', value)
    },
    onChangePrefecture(value) {
      this.$emit('change-prefecture', value)
    },
    onChangeAddress1(value) {
      this.$emit('change-address1', value)
    },
    onChangeAddress2(value) {
      this.$emit('change-address2', value)
    },
    onChangePhoneNumber(value) {
      this.$emit('change-phone-number', value)
    },
    onChangeEmail(value) {
      this.$emit('change-email', value)
    },
    onChangeIsAgreedPrivacyPolicy(value) {
      this.$emit('change-is-agreed-privacy-policy', value)
    },
    onChangeIsOverTwenty(value) {
      this.$emit('change-is-over-twenty', value)
    },
    focusAddress2() {
      this.$refs.deliveryAddressNewFormInputs.focusAddress2()
    }
  }
}
</script>
